import { Link, useSearchParams } from "react-router-dom";
import { AuthPageLayout } from "./auth-page-layout";
import { buttonVariants } from "@/components/ui/button";
import { resolveSafeNext, withNext } from "./next-redirect";
import { useT } from "@/i18n";
import { authMessages } from "@/i18n/messages/auth";

type ErrorKey = Extract<keyof typeof authMessages.en, `error${string}`>;

const ERROR_KEYS = new Map<string, ErrorKey>([
  ["oauth_failed", "errorOauthFailed"],
  ["oauth_cancelled", "errorOauthCancelled"],
  ["email_not_verified", "errorEmailNotVerified"],
  ["session_expired", "errorSessionExpired"],
]);

export function AuthErrorPage() {
  const t = useT(authMessages);
  const [params] = useSearchParams();
  const message = t(ERROR_KEYS.get(params.get("code") ?? "") ?? "errorUnknown");
  const nextUrl = resolveSafeNext(params.get("next"));

  return (
    <AuthPageLayout>
      <div className="auth-state-stack" data-testid="auth-error">
        <p className="auth-page-copy">{message}</p>

        <Link
          to={withNext("/auth/login", nextUrl)}
          className={buttonVariants({
            variant: "secondary",
            size: "lg",
            className: "auth-liquid-primary-button w-full font-semibold",
          })}
          data-testid="error-login-link"
        >
          {t("signIn")}
        </Link>
      </div>
    </AuthPageLayout>
  );
}
